import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type Allowance from 'modules/timeoff/store/models/Allowance'

export type CarryOver = {
  accumulated: number
  expire_in_months: number
  expired: number
  from_cycle_ending_on: string
}

interface Props {
  allowance: Allowance
  carryOver: CarryOver
  isHourlyFixedBalance: boolean
}

const Carryovers = ({ allowance, carryOver, isHourlyFixedBalance }: Props) => {
  const expiry = carryOver.from_cycle_ending_on
  const currentYear = moment(expiry).year()
  const expiryDate = moment(expiry).add(carryOver.expire_in_months, 'months')

  const expiryDateString = {
    date: dateToString(expiryDate, 'ui'),
  }

  const positiveCarryover = carryOver.accumulated > 0
  const expiredCarryover = carryOver.expired > 0
  const cycle = `${currentYear}/${currentYear}`

  const date = {
    date: cycle,
  }

  const title = i18n.t('time_off.accrued_tooltip.carried_over', date)

  const accumulated = allowance.isDays
    ? i18n.t('time_off.accrued_tooltip.available_days')
    : i18n.t('time_off.accrued_tooltip.available_hours')

  const willExpireOn = i18n.t('time_off.accrued_tooltip.expires_when', expiryDateString)

  const hasExpiredOn = i18n.t('time_off.accrued_tooltip.expired_when', expiryDateString)

  return (
    <Box>
      <Box flexDirection="row" justifyContent="flexStart" gap="s4">
        <Text.Normal capitalize>{title}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal size="200">{accumulated}</Text.Normal>
        <Text.Normal>
          {formatCounterAmount(carryOver.accumulated, isHourlyFixedBalance)}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        {positiveCarryover && <Text.Normal size="200">{willExpireOn}</Text.Normal>}
        {expiredCarryover && (
          <>
            <Text.Normal size="200">{hasExpiredOn}</Text.Normal>
            <Text.Normal>
              {formatCounterAmount(carryOver.expired, isHourlyFixedBalance)}
            </Text.Normal>
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(Carryovers)
